import { createStore }     from 'redux';
import { applyMiddleware } from 'redux';
import thunk               from 'redux-thunk';
import { jwt }             from '../utils/authService';
import rootReducer         from '../reducers';
//import LogRocket           from 'logrocket';

export default function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    applyMiddleware(jwt, thunk)
  );
}